var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useRegisterField } from '../../@common/hooks/use-register-field';
import ValidatedField from './validated-field';
export var NamedField = function (_a) {
    var fieldArrayState = _a.fieldArrayState, formState = _a.formState, providedName = _a.providedName, type = _a.type, componentProps = _a.componentProps, rest = __rest(_a, ["fieldArrayState", "formState", "providedName", "type", "componentProps"]);
    var _b = useRegisterField(fieldArrayState, formState, providedName, type, false, componentProps.defaultValue), field = _b.field, isInsideForm = _b.isInsideForm, isRegistered = _b.isRegistered, name = _b.name;
    if ((isInsideForm && !field) || !isRegistered) {
        return null;
    }
    return (React.createElement(ValidatedField, __assign({}, rest, { componentProps: componentProps, formRef: formState === null || formState === void 0 ? void 0 : formState.formRef, field: field, name: name, type: type })));
};
